import React from 'react';
import { SprievodnyDokumentStatus } from 'evidencna-aplikacia-web-ts-axios';

export interface SprievodnyDokumentContextContent {
  vznesenePripomienkyExistsStatus: SprievodnyDokumentStatus | undefined,
  fetchVznesenePripomienkyExistsStatus: (legMaterialUuid: string, sprievodnyDokumentKod: string) => void;
}

export default React.createContext<SprievodnyDokumentContextContent>({
  vznesenePripomienkyExistsStatus: undefined,
  fetchVznesenePripomienkyExistsStatus: () => { /* noop */ },
});
